export const MODAL_BACK_BUTTON_NAME = 'ftv-magneto-modal-btn-back';

export const MODAL_BASIC_STYLE = {
  default: {
    width: 480,
    height: 'auto'
  },
  'small+extraSmall': {
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '100%',
    right: 0,
    top: 0,
    borderRadius: 0
  }
};

export const MODAL_CLOSING_BUTTON_STYLE = {
  default: { display: 'flex', position: 'absolute', right: 18, top: 20 },
  extraSmall: { right: 15, top: 21 },
  small: { right: 18, top: 22 }
};
